<template>
  <div class="page-container">
    <van-nav-bar fixed left-arrow title="订单确认" :z-index="10" @click-left="goableBack()"></van-nav-bar>
    <div class="top-contain">
      <template v-if="Object.keys(address).length > 0">
        <van-cell class="cell-1" is-link center @click="onSelectAddress">
          <div class="address-bg">
            <div>{{ address.area }}</div>
            <div class="area">{{ address.detailAddress }}</div>
            <div>{{ address.custName }}&nbsp;{{ address.phone }}</div>
          </div>
        </van-cell>
      </template>

      <van-cell class="cell-2">
        <div class="c2-1">兑换商品</div>
        <div class="c2-2">
          <img :src="selectSkuItem.path" alt="商品图片" fit="cover" />
          <div class="c2-3">
            <div class="c2-4">
              {{ goodsItem.typeName }}&nbsp;{{ goodsItem.title }}
            </div>
            <div class="c2-5">
              <template v-if="goodsItem.code == 2 || goodsItem.code == 10">
                <div class="c2-6">{{ selectSkuItem.score }}积分</div>
              </template>
              <template v-else>
                <div class="c2-6">
                  ¥{{ (selectSkuItem.price / 100).toFixed(1) }}
                </div>
              </template>
              <div class="c2-7">x{{ selectSkuItem.num }}</div>
            </div>
          </div>
        </div>
        <div v-if="goodsItem.code != 2 && goodsItem.code != 8 && goodsItem.code != 10">
          <van-tag round plain :class="payType == 1 ? 'sku-item-select' : 'sku-item-normal'" @click="payType = 1">积分+现金支付</van-tag>
          <van-tag round plain :class="payType == 2 ? 'sku-item-select' : 'sku-item-normal'" @click="payType = 2">现金支付</van-tag>
        </div>
      </van-cell>
      <template v-if="goodsItem.code != 2 && goodsItem.code != 8 && goodsItem.code != 10">
        <div class="cell-3">
          <div v-if="payType == 1" class="cell-3-1">
            <div class="cell-3-1-1">
              <span class="cell-3-1-1-1">积分抵扣</span>
              <span class="cell-3-1-1-2">&nbsp;&nbsp;&nbsp;&nbsp;账户积分：</span>
              <span class="cell-3-1-1-3">{{ userInfo.sumScore || 0 }}</span>
            </div>
            <van-field class="amount-input" type="digit" v-model="payAmountTemp" :placeholder="
                '(最高抵扣积分：' +
                selectSkuItem.score * selectSkuItem.num +
                ')'
              " @input="onInput">
              <div slot="left-icon">积分：</div>
              <div slot="right-icon" style="color: rgb(233, 0, 37)" @click="onClearAmount">
                清空&nbsp;
              </div>
            </van-field>
            <div class="cell-3-1-2">
              <span class="cell-3-1-2-1">抵扣金额：</span>
              <span class="cell-3-1-2-2">{{ dikouAmount }}</span>
            </div>
            <div class="cell-3-1-3">
              温馨提示：本商品最高可使用{{
                selectSkuItem.score * selectSkuItem.num
              }}积分抵扣{{ jifendikouAmount }}元，最高不超过商品总价的{{
                goodsItem.scoreDeduction || 0
              }}%。
            </div>
          </div>
          <div v-show="isShowPayType" class="cell-3-2 cell-3-3">
            <div class="cell-tips">现金支付选择：</div>
            <van-checkbox-group v-model="selectPayItem" ref="checkboxGroup" :max="1">
              <van-cell-group>
                <van-cell class="cell-3-2-1" v-for="(item, index) in payTyleList" :key="item.value" :title="item.title" @click="toggle(index)">
                  <template #right-icon>
                    <van-checkbox :name="item.value" checked-color="rgb(233, 0, 37)" ref="checkboxes" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </div>
          <div v-if="payType == 1" class="cell-3-2">
            <van-cell class="cell-3-2-1" title="商品总额" :value="
                '¥' +
                ((selectSkuItem.price / 100) * selectSkuItem.num).toFixed(1)
              "></van-cell>
            <van-cell class="cell-3-2-2" title="抵扣积分" :value="(payAmount || 0) + '积分'"></van-cell>
          </div>
        </div>
      </template>
      <van-cell v-if="decreCashCouponList.data.length > 0 && (goodsItem.code != 2 && goodsItem.code != 8 && goodsItem.code != 10)" center title="满减券" label="根据商品总额查看可用的满减券" class="fs-14 mt-10" @click="onClickDecreCashCouponCell">
        <template #right-icon>
          <span class="fs-14" v-if="!decreCashCouponAmount">
            <span v-if="decreCashCouponTips.indexOf('可用') > 0" class="tips-color">
              {{ decreCashCouponTips }}
            </span>
            <span v-else>
              {{ decreCashCouponTips }}
            </span>
          </span>
          <span v-else style="color: red">-{{ decreCashCouponAmount }}</span>
          <van-icon name="arrow" />
        </template>
      </van-cell>
    </div>
    <div class="bottom-contain">
      <div class="integralbg">
        <div class="integral">
          <span>合计：</span>
          <template v-if="goodsItem.code != 2 && goodsItem.code != 8 && goodsItem.code != 10">
            <template v-if="payType == 1">
              <template v-if="payAmount > 0">
                <template v-if="
                    ((selectSkuItem.price / 100) * selectSkuItem.num).toFixed(
                      1
                    ) -
                      dikouAmount >
                    0
                  ">
                  <span v-if="(
                        (
                          (selectSkuItem.price / 100) *
                          selectSkuItem.num
                        ).toFixed(1) - dikouAmount - decreCashCouponAmount
                      ).toFixed(1) > 0" class="value">¥{{
                      (
                        (
                          (selectSkuItem.price / 100) *
                          selectSkuItem.num
                        ).toFixed(1) - dikouAmount - decreCashCouponAmount
                      ).toFixed(1)
                    }}</span>
                  <span v-else class="value">¥0</span>
                  <span class="value">+{{ payAmount || 0 }}积分</span>
                  <span class="manjian" v-if="decreCashCouponAmount && decreCashCouponAmount > 0">(已减{{ decreCashCouponAmount }}元)</span>
                </template>
                <template v-else>
                  <span class="value">{{ payAmount || 0 }}积分</span>
                </template>
              </template>
              <template v-else>
                <span v-if="((selectSkuItem.price / 100) * selectSkuItem.num - decreCashCouponAmount).toFixed(1) > 0" class="value">¥{{
                   ((selectSkuItem.price / 100) * selectSkuItem.num - decreCashCouponAmount).toFixed(1)
                  }}</span>
                <span v-else class="value">¥0</span>
                <span class="manjian" v-if="decreCashCouponAmount && decreCashCouponAmount > 0">(已减{{ decreCashCouponAmount }}元)</span>
              </template>
            </template>
            <template v-else>
              <span v-if="((selectSkuItem.price / 100) * selectSkuItem.num - decreCashCouponAmount).toFixed(1) > 0" class="value">¥{{
                 ((selectSkuItem.price / 100) * selectSkuItem.num - decreCashCouponAmount).toFixed(1)
                }}</span>
            </template>
          </template>
          <template v-else>
            <span class="value">{{ selectSkuItem.score * selectSkuItem.num || 0 }}积分</span>
          </template>
        </div>
      </div>
      <div class="redeemNowbg" @click="clickConfirmRedeem">
        <div class="redeemNow">确认支付</div>
      </div>
    </div>
    <password-input-pop :visible.sync="showPwdInput" :password.sync="password" @startPay="startPay"></password-input-pop>
    <pay-success :showPaySuccess.sync="showPaySuccess" @onSure="onJumpMall">
    </pay-success>
    <van-popup ref="couponPopup" v-model="showDecreCashCouponPopup" class="cash-coupon-list" closeable @open="openDecreCashCouponPopup" @close="comfirmCheckedDecreCashCoupon" close-icon="close" close-icon-position="top-right" position="bottom" round>
      <van-tabs v-model="decreCashCouponActiveName">
        <van-tab :title="
            '可用满减券(' + this.decreCashCouponList.available.length + ')'
          " name="available">
          <div class="cash-coupon-panel">
            <van-checkbox-group @change="checkedDecreCashCouponChanged" v-model="decreCashCouponList.checked">
              <div class="coupon-cell-container" v-for="item in decreCashCouponList.available" :key="item.id">
                <div class="coupon_checkbox">
                  <van-checkbox :disabled="item.disabled" :name="item.id" checked-color="#c7a673">
                  </van-checkbox>
                </div>
                <van-cell>
                  <template #title>
                    <div class="coupon_item_container">
                      <van-row type="flex">
                        <van-col span="9">
                          <div class="coupon_item_left">
                            <span>
                              <em>¥</em>
                              <span> {{ item.perAmount / 100 || 0 }} </span>
                            </span>
                            <span style="font-size: 10px">
                              满{{ item.amount / 100 || 0 }}元可用
                            </span>
                          </div>
                        </van-col>
                        <van-col span="1">
                          <div class="coupon_border" />
                        </van-col>
                        <van-col span="14">
                          <div class="coupon_item_right">
                            <span class="fs-12"> {{ item.name }} </span>
                            <br />
                            <span style="font-size: 10px">
                              {{ dateSplit(item.takeEffectTime) }}
                              <span> 至 </span>
                              {{ dateSplit(item.expiryTime) }}
                            </span>
                            <br />
                            <template v-if="item.label && item.label > 0">
                              <div class="label-bg">
                                <span class="if_label">{{
                                  item.lableString
                                }}</span>
                              </div>
                            </template>
                          </div>
                        </van-col>
                      </van-row>
                    </div>
                  </template>
                </van-cell>
              </div>
            </van-checkbox-group>
          </div>
          <div class="fixed-popup-bottom">
            <div style="margin-bottom: 5px">
              <span @click="showDecreCashCouponUseRules = true">使用规则</span>
              <van-icon name="question"></van-icon>
            </div>
            <van-button @click="comfirmCheckedDecreCashCoupon" round type="danger">
              确 定
            </van-button>
          </div>
        </van-tab>
        <van-tab :title="
            '不可用满减券(' + this.decreCashCouponList.inavailable.length + ')'
          " name="inavailable">
          <div class="cash-coupon-panel">
            <div class="coupon-cell-container" v-for="item in decreCashCouponList.inavailable" :key="item.id">
              <van-cell>
                <template #title>
                  <div class="coupon_item_container">
                    <van-row type="flex">
                      <van-col span="9">
                        <div class="coupon_item_left">
                          <span>
                            <em>¥</em>
                            <span> {{ item.perAmount / 100 }}</span>
                          </span>
                          <span style="font-size: 10px">
                            满{{ item.amount / 100 }}元可使用
                          </span>
                        </div>
                      </van-col>
                      <van-col span="1">
                        <div class="coupon_border" />
                      </van-col>
                      <van-col span="14">
                        <div class="coupon_item_right">
                          <span class="fs-12"> {{ item.name }} </span>
                          <br />
                          <span style="font-size: 10px">
                            {{ dateSplit(item.takeEffectTime) }}
                            <span> 至 </span>
                            {{ dateSplit(item.expiryTime) }}
                          </span>
                          <br />
                          <template v-if="item.label && item.label > 0">
                            <div class="label-bg">
                              <span class="if_label">{{
                                item.lableString
                              }}</span>
                            </div>
                          </template>
                        </div>
                      </van-col>
                    </van-row>
                  </div>
                </template>
              </van-cell>
            </div>
          </div>
          <div class="fixed-popup-bottom">
            <div style="margin-bottom: 5px">
              <span @click="showDecreCashCouponUseRules = true">使用规则</span>
              <van-icon name="question"></van-icon>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </van-popup>
    <van-dialog v-model="showDecreCashCouponUseRules" title="卡券使用规则">
      <div class="tips-dialog fs-14">
        <span>1、同类型卡券为可叠加时，可叠加多张使用；</span><br />
        <span>2、不同类型多张卡券同时使用时,只能各用一张；</span><br />
        <span>3、具备任意叠加属性的券可以和任何情况下的任何券叠加；</span><br />
        <span>4、商城运营方有最终解释权。</span><br />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import PasswordInputPop from "../../../components/PasswordInputPop.vue"
import PaySuccess from "./paySuccess.vue"
import PickupCode from "./pickupCode.vue"

import * as MallApi from "@/api/mall"
import { mapActions } from "vuex"
import {
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Dialog,
  Field,
  Tag,
  Popup,
  Tabs,
  Tab,
  Icon,
  Col,
  Row,
} from "vant"
import session from "../../../utils/session"
import { authorize } from "../../../assets/js/authorize"
import Url from "url"

export default {
  name: "confirmOrder",
  components: {
    PasswordInputPop,
    PaySuccess,
    PickupCode,
    [Tag.name]: Tag,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Col.name]: Col,
    [CheckboxGroup.name]: CheckboxGroup,
    [CellGroup.name]: CellGroup,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Row.name]: Row,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      showPwdInput: false,
      showPaySuccess: false,
      password: "",
      selectSkuItem: {},
      goodsItem: {},
      address: {},
      payType: 1, // 支付方式 1 现金+积分 2 现金
      payAmountTemp: "",
      payAmount: 0,

      cashType: -1, // 现金支付类型 0 余额 1 微信
      code: "", // 微信支付时需要

      isShowPayType: true,
      selectPayItem: [],
      payTyleList: [
        { title: "微信支付", icon: "", value: 1 },
        { title: "余额支付", icon: "", value: 0 }
      ],
      // 微信支付参数
      payData: {
        appId: "",
        timeStamp: "",
        nonceStr: "",
        package: "",
        signType: "",
        paySign: ""
      },
      enterTime: 0,

      decreCashCouponIds: [],
      decreCashCouponActiveName: "available",
      showDecreCashCouponPopup: false,
      decreCashCouponTips: "",
      showDecreCashCouponUseRules: false,
      decreCashCouponAmount: null,
      decreCashCouponList: {
        loading: false,
        finished: false,
        data: [],
        available: [],
        inavailable: [],
        checked: []
      },
    }
  },
  watch: {
    payAmountTemp: function (val) {
      if (val > 0) {
        this.payAmount = val
      } else {
        this.payAmount = 0
      }
      this.isShowPayType = this.showPayTypeSelect()
    },
    payType: function (val) {
      if (val == 2) {
        this.payAmountTemp = ""
        this.payAmount = 0
      }
    },
    "decreCashCouponList.checked": {
      handler(checkedCashCoupon) {
        if (checkedCashCoupon.length >= 0) {
          this.decreCashCouponAmount = checkedCashCoupon
            .map((id) => {
              let item = this.decreCashAvailableCouponMap.get(id)
              return (item.perAmount / 100)
            })
            .reduce((p1, p2) => p1 + p2, 0)
        }
        this.decreCashCouponIds = checkedCashCoupon
      },
      deep: true
    },
  },
  mounted() {
    this.enterTime = Date.now()
    this.selectSkuItem = JSON.parse(session.getJson("confirmOrderKey")) || {}
    if (this.$route.query.selectItem && this.$route.query.selectItem.id) {
      this.address = this.$route.query.selectItem
    } else {
      this.address = this.selectSkuItem.address
    }

    this.getUserInfo()
    this.getOrderDetial()
  },
  computed: {
    dikouAmount() {
      let price = this.payAmount / this.userInfo.scoreExchangeRate
      let totalPrice = (this.selectSkuItem.price / 100) * this.selectSkuItem.num
      if (price >= totalPrice) {
        return totalPrice.toFixed(1)
      } else {
        return price.toFixed(1)
      }
    },
    jifendikouAmount() {
      let totalPrice = (this.selectSkuItem.price / 100) * this.selectSkuItem.num
      let price = (this.selectSkuItem.score * this.selectSkuItem.num) / this.userInfo.scoreExchangeRate
      if (price >= totalPrice) {
        return totalPrice.toFixed(1)
      } else {
        return price.toFixed(1)
      }
    },
    decreCashAvailableCouponMap() {
      let map = new Map()
      this.decreCashCouponList.data.forEach((item) => {
        map.set(item.id, item)
      })
      return map
    },
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    showPayTypeSelect() {
      if (
        this.goodsItem.scoreDeduction == 100 &&
        this.payAmount == this.selectSkuItem.score * this.selectSkuItem.num
      ) {
        this.cashType = 0
        this.$nextTick(() => {
          this.$refs.checkboxGroup.toggleAll(false)
          this.$refs.checkboxes[1].toggle(true)
        })
        return false
      } else {
        return true
      }
    },
    // 获取商品详情
    getOrderDetial() {
      MallApi.getGoodsDetail(this.selectSkuItem.goodsId)
        .then((data) => {
          if (data) {
            this.goodsItem = data
            // this.handleAutoCreateOrder()
            this.loadGetGoodsRedPacket()
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    clickConfirmRedeem() {
      if (this.goodsItem.code != 2 && this.goodsItem.code != 8 && this.goodsItem.code != 10) {
        if (
          (this.cashType == 0 && this.isShowPayType) ||
          (this.payType == 2 && this.cashType == 0)
        ) {
          if (!this.userInfo.isBindCard) {
            this.tipsNoBindCard()
            return
          }
          let payPrice =
            (this.selectSkuItem.price / 100) * this.selectSkuItem.num -
            this.payAmount / this.userInfo.scoreExchangeRate
          if (payPrice > this.userInfo.custAccount.balance / 100) {
            this.tipsRecharge()
            return
          }
        }
        if (this.userInfo.sumScore < this.payAmount) {
          this.$toast("您的积分不足，请重新选择")
        } else {
          this.selectPayType()
        }
      } else {
        if (
          this.userInfo.sumScore <
          this.selectSkuItem.score * this.selectSkuItem.num
        ) {
          this.$toast("您的积分不足，请重新选择")
        } else {
          this.showPwdInput = true
        }
      }
    },
    tipsNoBindCard() {
      this._showTipsInfo(
        "温馨提示",
        "您的账户目前未绑定银行卡，请前往绑定",
        "关闭",
        "确认",
        () => {
          session.setJson("cq", { target: "confirmOrder" })
          this.$router.push({ name: "bindcard" })
        },
        () => { }
      )
    },
    tipsRecharge() {
      this._showTipsInfo(
        "温馨提示",
        "您的账户余额不足，请先去充值",
        "关闭",
        "确认",
        () => {
          // this.$router.push({ name: "recharge_1" })
          this.$router.push({
            name: "recharge_offline",
            query: { redirect: this.$route.fullPath }
          })
        },
        () => { }
      )
    },
    tipsInfo() {
      this._showTipsInfo(
        "温馨提示",
        "确认兑换后请前往“我的兑换”中进行充值卡使用。",
        "",
        "好的",
        () => {
          if (this.cashType == 0) {
            this.showPwdInput = true
          } else {
            this.getWechatCode()
          }
        },
        () => { }
      )
    },
    selectPayType() {
      if (
        this.goodsItem.scoreDeduction == 100 &&
        this.payAmount == this.selectSkuItem.score * this.selectSkuItem.num
      ) {
        // code类型：1 加息券 2 代金券 3 京东E卡 4 盒马鲜生 5 黑猪礼品卡 6 话费充值卡 10 返现券
        if (this.goodsItem.code == 6) {
          this.tipsInfo()
        } else {
          this.showPwdInput = true
        }
      } else {
        if (this.cashType == -1) {
          this.$toast("请先选择现金支付方式！")
        } else {
          if (this.goodsItem.code == 6) {
            this.tipsInfo()
          } else {
            if (this.cashType == 0) {
              this.showPwdInput = true
            } else {
              this.getWechatCode()
            }
          }
        }
      }
    },
    getWechatCode() {
      if (this.isWechant()) {
        let url = Url.parse(location.href, true)
        if (url.query.code && url.query.code.length > 0) {
          let nowTime = Date.now()
          if (parseInt((nowTime - this.enterTime) / 1000) >= 60) {
            // 5分钟
            let params = this.getCreateOrderParams()
            params.catchParams = "1"
            session.setJson("createOrderInfoKey", params)
            if (location.href.indexOf("?") >= 0) {
              authorize(
                `${location.href.split("?")[0]}#${this.$route.fullPath}`
              )
            } else {
              authorize(
                `${location.href.split("#")[0]}#${this.$route.fullPath}`
              )
            }
          } else {
            this.code = url.query.code
            this.startPay()
          }
        } else {
          let params = this.getCreateOrderParams()
          params.catchParams = "1"
          session.setJson("createOrderInfoKey", params)
          if (location.href.indexOf("?") >= 0) {
            authorize(`${location.href.split("?")[0]}#${this.$route.fullPath}`)
          } else {
            authorize(`${location.href.split("#")[0]}#${this.$route.fullPath}`)
          }
        }
      } else {
        this.$toast("请在微信浏览器中打开，再进行支付！")
      }
    },
    handleAutoCreateOrder() {
      let params = session.getJson("createOrderInfoKey")
      let url = Url.parse(location.href, true)
      if (params && params.catchParams) {
        params.catchParams = undefined
        this.code = url.query.code || ""
        this.password = params.payPwd
        this.payAmount = params.payAmount
        this.payAmountTemp = params.payAmount
        this.payType = params.payType
        this.cashType = params.cashType
        this.decreCashCouponIds = params.redRecordIds
        this.decreCashCouponList.checked = params.redRecordIds || []
        if (this.cashType != -1) {
          this.$nextTick(() => {
            this.$refs.checkboxGroup.toggleAll(false)
            this.$refs.checkboxes[this.cashType == 0 ? 1 : 0].toggle(true)
          })
        }
        this.startPay()
      }
    },
    onJumpMall() {
      if (this.cashType == 1) {
        this.$router.go(-3)
      } else {
        this.$router.go(-1) //回到商城列表
      }
      setTimeout(() => {
        this.$router.replace({ name: "myExchange" })
      }, 500)
    },
    getCreateOrderParams() {
      let params = {
        goodsId: this.selectSkuItem.goodsId,
        skuId: this.selectSkuItem.id,
        num: this.selectSkuItem.num,
        payPwd: this.password,
        payAmount: this.payAmount,
        payType: this.payType,
        clientType: 1, // 0 未知 1 公众号 2 app
        cashType: this.cashType,
        code: this.code,
        redRecordIds: this.decreCashCouponIds
      }
      if (Object.keys(this.address).length > 0) {
        params.addressId = this.address.id
      }
      return params
    },
    startPay() {
      //code类型：1 加息券 2 代金券 3 京东E卡 4 盒马鲜生 5 黑猪礼品卡 6 话费卡 7 实物卡 10 返现券
      session.del("createOrderInfoKey")
      MallApi.orderConfirm(this.getCreateOrderParams())
        .then((data) => {
          // session.del("confirmOrderKey")
          if (data) {
            if (this.cashType == 1) {
              session.set("ConfirmOrderIDKey", data.orderId)
              this.payData = {
                appId: data.prePay.appId || "",
                timeStamp: data.prePay.timeStamp || "",
                nonceStr: data.prePay.nonceStr || "",
                package: data.prePay.packageVal || "",
                signType: data.prePay.signType || "",
                paySign: data.prePay.paySign || ""
              }
              this.bindWeixinJSBridge()
            } else {
              this.showPaySuccess = true
            }
            this.getUserInfo()
          }
        })
        .catch((e) => {
          if (e.code == 2007) {
            Dialog.alert({
              title: "温馨提示",
              message: "支付密码尚未设置，请先设置支付密码！",
              confirmButtonText: "去设置",
              showCancelButton: true,
              theme: "round-button"
            })
              .then(() => {
                this.$router.push({ name: "settingPwd" })
              })
              .catch(() => { })
          } else if (e.code == 2011) {
            this.tipsRecharge()
          } else {
            this.$toast(e.msg || e.message)
          }
        })
    },
    bindWeixinJSBridge() {
      if (typeof window.WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.jsApiCall,
            false
          )
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.jsApiCall)
          document.attachEvent("onWeixinJSBridgeReady", this.jsApiCall)
        }
      } else {
        this.jsApiCall()
      }
    },
    jsApiCall() {
      window.WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        this.payData,
        (res) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            this.wxPayResult()
          } else {
            // this.$toast("支付失败")
            this.wxPayResult()
          }
        }
      )
    },
    wxPayResult() {
      let orderId = session.get("ConfirmOrderIDKey")
      if (orderId) {
        session.del("ConfirmOrderIDKey")
        MallApi.wxPayResultQuery({
          orderId: orderId,
          clientType: 1
        })
          .then((data) => {
            this.showPaySuccess = true
          })
          .catch((e) => {
            this.$toast(e.msg || e.message)
          })
      }
    },
    // 失去焦点，如果
    setAmountInMin() { },
    onInput() {
      if (
        this.payAmountTemp >
        this.selectSkuItem.score * this.selectSkuItem.num
      ) {
        this.payAmountTemp = this.selectSkuItem.score * this.selectSkuItem.num
      }
    },
    onClearAmount() {
      this.payAmountTemp = ""
      this.payAmount = 0
    },
    onSelectAddress() {
      this.$router.push({
        name: "myaddress",
        query: { handleSelect: 1 }
      })
    },

    toggle(index) {
      this.$refs.checkboxGroup.toggleAll(false)
      this.$refs.checkboxes[index].toggle(true)
      this.cashType = this.payTyleList[index].value
    },
    loadGetGoodsRedPacket() {
      MallApi.getGoodsRedPacket(this.selectSkuItem.goodsId).then((couponList) => {
        if (couponList && couponList.length > 0) {
          this.decreCashCouponList.data = couponList
          let decreCashCouponLength = this.decreCashCouponList.data.length
          this.decreCashCouponTips =
            decreCashCouponLength > 0
              ? `有${decreCashCouponLength}张券`
              : "无"
          this.decreCashCouponList.loading = false
          this.decreCashCouponList.finished = true

          this.decreCashCouponList.available =
            this.filterDecreCashCoupon(true)
          if (this.decreCashCouponList.available.length > 0) {
            this.decreCashCouponTips = "本次可用券"
          } else {
            this.decreCashCouponTips = `有${this.decreCashCouponList.data.length}张券`
          }
        } else {
          this.decreCashCouponTips = "无"
        }
        this.handleAutoCreateOrder()
      }).catch(e => {
        this.decreCashCouponList.loading = false
        this.decreCashCouponList.finished = true
        this.$toast(err.msg)
      })
    },
    comfirmCheckedDecreCashCoupon() {
      this.showDecreCashCouponPopup = false
    },
    checkedDecreCashCouponChanged(checkedValueArray) {
      if (this.decreCashCouponAmount > this.getTotalAmount()) {
        this.decreCashCouponList.available =
          this.decreCashCouponList.available.map((coupon) => {
            if (checkedValueArray.find((id) => id == coupon.id)) {
              coupon.disabled = false
            } else {
              coupon.disabled = true
            }
            return coupon
          })
      } else {
        //如果没有不可叠加的红包，那把之前禁用的红包启用
        this.decreCashCouponList.available =
          this.decreCashCouponList.available.map((coupon) => {
            if (coupon.disabled) {
              coupon.disabled = false
              return coupon
            }
            return coupon
          })
      }
      let yijianAmount = checkedValueArray.map(
        (checkedRedpacketId) => {
          let checkedPacket =
            this.decreCashAvailableCouponMap.get(checkedRedpacketId)
          return (checkedPacket.amount / 100)
        }
      ).reduce((p1, p2) => p1 + p2, 0)
      this.decreCashCouponList.available =
        this.decreCashCouponList.available.map((coupon) => {
          if (!coupon.disabled) {
            const amount = (coupon.amount / 100)
            if (amount > this.getTotalAmount() - yijianAmount && !this.decreCashCouponList.checked.includes(coupon.id)) {
              coupon.disabled = true
            }
          }
          return coupon
        })
    },
    openDecreCashCouponPopup() {
      this.checkedDecreCashCouponChanged(this.decreCashCouponList.checked)
      this.decreCashCouponList.inavailable = this.filterDecreCashCoupon(false)
    },

    //分割日期时间
    dateSplit(val) {
      if (!val) return ""
      return val.split(" ")[0]
    },

    onClickDecreCashCouponCell() {
      this.showDecreCashCouponPopup = this.decreCashCouponList.data.length > 0
    },

    /**
     * 判断红包类的卡券(满减券)不是可用
     */
    redpacketCouponAvailable(item) {
      let tradeAmountNumber = Number(
        this.getTotalAmount() || 0
      )
      // 0 未使用
      return (this.isRedPacketAvailable(item.expiryTime, item.takeEffectTime) == true && Number(item.amount / 100 || 0) <= tradeAmountNumber)
    },

    /**
     * 判断红包类的卡券(加息、代金、满减券)不是不可用
     */
    redpacketCouponInavailable(item) {
      let tradeAmountNumber = Number(
        this.getTotalAmount() || 0
      )
      return (Number(item.amount / 100 || 0) > Number(tradeAmountNumber) || !this.isRedPacketAvailable(item.expiryTime, item.takeEffectTime))
    },

    /// 过滤满减券是否可用
    filterDecreCashCoupon(available) {
      return this.decreCashCouponList.data.filter((item) => {
        if (available == true) {
          return this.redpacketCouponAvailable(item)
        } else {
          return this.redpacketCouponInavailable(item)
        }
      })
    },
    isRedPacketAvailable(expiryTime, takeEffectTime) {
      const expiryTimeNow = new Date(expiryTime).getTime()
      const takeEffectTimeNow = new Date(takeEffectTime).getTime()
      return this.userInfo.serverTime >= takeEffectTimeNow && this.userInfo.serverTime <= expiryTimeNow
    },
    getTotalAmount() {
      return ((this.selectSkuItem.price / 100) * this.selectSkuItem.num).toFixed(1) || 0
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  height: calc(100vh - 55px);
}
.top-contain {
  padding-bottom: 60px;
  .cell-1 {
    background-color: white;
    margin-top: 0px;
    margin-bottom: 10px;
    border-radius: 6px;
    .address-bg {
      .area {
        font-size: 16px;
        font-weight: 800;
        margin: 5px 0;
      }
    }
  }
  .cell-2 {
    border-radius: 6px;
    background-color: white;
    margin-bottom: 10px;
    .c2-1 {
    }
    .c2-2 {
      margin-top: 15px;
      display: flex;
      justify-content: space-around;
      margin-bottom: 10px;
      img {
        flex: 0.4;
        width: 100px;
        height: 70px;
        object-fit: fill;
        border-radius: 10px;
        margin-right: 15px;
      }
      .c2-3 {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        .c2-4 {
          font-size: 13px;
          font-weight: 500;
        }
        .c2-5 {
          display: flex;
          justify-content: space-between;
          margin-top: 10px;
          .c2-6 {
            color: rgb(233, 0, 37);
          }
        }
      }
    }
    .sku-item-normal,
    .sku-item-select {
      margin: 15px 30px 5px 0px;
      padding: 4px 10px;
    }
    .sku-item-normal {
      background-color: rgb(233, 233, 233);
      color: rgb(118, 118, 118);
      border: 0 solid transparent;
    }
    .sku-item-select {
      background-color: rgb(249, 214, 216);
      // border: 0px solid rgb(233, 0, 37);
      color: rgb(233, 0, 37);
    }
  }
  .cell-3 {
    background-color: transparent;
    .cell-3-1 {
      padding: 10px 15px;
      border-radius: 6px;
      background-color: white;
      color: rgb(118, 118, 118);
      .cell-3-1-1-2 {
        color: rgb(26, 26, 26);
      }
      .cell-3-1-1-3 {
        color: rgb(233, 0, 37);
      }
      .amount-input {
        margin: 15px 0 10px 0;
        padding: 3px 10px;
        border: 1px solid rgb(236, 236, 236);
        border-radius: 6px;
        font-size: 14px;
      }
      .cell-3-1-2 {
        color: rgb(26, 26, 26);
        .cell-3-1-2-2 {
          font-weight: 700;
        }
      }
      .cell-3-1-3 {
        font-size: 12px;
        margin: 2px 0 10px 0;
      }
    }
    .cell-3-2 {
      margin-top: 10px;
      border-radius: 6px;
      background-color: white;
      .van-hairline--top-bottom::after,
      .van-hairline-unset--top-bottom::after {
        border-width: 0;
      }
      .van-cell:not(:last-child)::after {
        border-bottom: 0 solid white;
      }
      .cell-3-2-1,
      .cell-3-2-2 {
        .van-cell__title {
          color: rgb(118, 118, 118);
        }
        .van-cell__value {
          color: rgb(26, 26, 26);
        }
      }
      .cell-3-2-2 {
        margin-top: -10px;
      }
    }
    .cell-3-3 {
      .cell-tips {
        padding: 10px 15px;
      }
    }
  }
}
.cash-coupon-list {
  overflow: hidden;
  // 漏出底部的确定按钮，避免遮住滑动条
  padding-bottom: 90px;

  ::v-deep .van-checkbox {
    padding: 10px;
    // background: @gray-dark;
    background: white;
    font-size: 16px;

    .van-checkbox__label {
      color: #666666;
    }

    .van-checkbox__icon {
      position: relative;
      top: 1px;

      .van-icon {
        border-width: 1px;
      }
    }
  }

  .cash-coupon-panel {
    width: 100%;
    height: 12rem;
    overflow-y: auto;
    background-color: #f1f5f8d0;

    .coupon-cell-container {
      position: relative;
      border: 1px solid #fff;
      border-radius: 5px;
      box-shadow: 0 3px 3px #bdbdbd;
      border-top: 5px solid rgb(252, 101, 36);
      margin: 15px;

      .coupon_checkbox {
        position: absolute;
        right: 15px; //负值为自身体积的一半
        z-index: 800;
        top: calc(50% - 20px);
        display: flex;
        justify-content: center;
        background-color: white;
        border-radius: 9px;
      }
    }
    .coupon_item_container {
      position: relative;

      .coupon_item_left {
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: white;
        height: 100%;
        background: url("../../../assets/img/coupon/coupon.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        span {
          font-size: 20px;
        }
      }

      .coupon_item_right {
        margin-left: 15px;

        .if-any-superposition {
          font-size: 10px;
          border-radius: 20px;
          padding: 3px 10px;
          color: white;
          background-color: #ff9900;
        }
        .if-superposition {
          font-size: 10px;
          border-radius: 20px;
          padding: 3px 10px;
          color: white;
          background-color: rgb(252, 101, 36);
        }

        .if-no-superposition {
          font-size: 10px;
          border-radius: 10px;
          padding: 3px 5px;
          background-color: #e7eaed;
        }
        .label-bg {
          margin-top: 5px;
          .if_label {
            font-size: 10px;
            padding: 3px 5px;
            border-radius: 10px;
            color: white;
            background-color: rgb(228, 152, 20);
          }
        }
      }
    }
  }

  .fixed-popup-bottom {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    bottom: 0;
    width: 100%;
    height: 90px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;

    button {
      width: 80%;
      padding: 20px;
      border-radius: 25px;
    }
  }
}
.bottom-contain {
  position: fixed;
  display: flex;
  left: 0;
  right: 0;
  bottom: 0;
  height: 50px;
  .integralbg {
    flex: 2;
    display: flex;
    background-color: white;
    .integral {
      margin: auto 0;
      margin-left: 30px;
      color: rgb(46, 46, 46);
      font-size: 15px;
      .value {
        color: rgb(233, 0, 37);
      }
      .manjian {
        font-size: 10px;
        color: rgb(233, 0, 37);
      }
    }
  }
  .redeemNowbg {
    display: flex;
    flex: 1;
    background-color: rgb(222, 188, 120);
    .redeemNow {
      margin: auto;
      color: white;
      font-size: 16px;
      font-weight: 500;
    }
  }
}
.tips-dialog {
  padding: 10px;
  letter-spacing: 2px;
  line-height: 0.7rem;
}
</style>